import store from '../store/index'
//--------------------
// get current action
//--------------------
export default function getCurrentAction(combatants) {
  console.log('-----------------------')
  console.log('IN getCurrentAction')
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let maxCA = this_store.config.max_ca
  let return_parm = {
    cur_action: 0,
    unused_action_count: 0,
  }
  //----------
  // loop cas
  //----------
  for (let i = 1; i <= maxCA; i++) {
    // set ca name
    let ca_name = 'ca_name' + i
    let ca_type = 'ca_type' + i
    //---------------------------
    // get pending count this ca
    //---------------------------
    let pending_combatants = combatants.filter((a) => a[ca_name] == 'pending')
    //-------------------------
    // get delay count this ca
    //-------------------------
    let delay_combatants = combatants.filter((a) => a[ca_name] == 'delay')
    //--------------------------
    // get markers count this ca
    //---------------------------
    let marker_combatants = combatants.filter((a) => a[ca_type] == 'marker')
    // console.log("pending_combatants = " + pending_combatants.length)
    // console.log("delay_combatants = " + delay_combatants.length)
    // console.log("marker_combatants = " + marker_combatants.length)
    //---------------------------------------------------------
    // where combatants with pending action, delay, or marker
    //---------------------------------------------------------
    if (
      pending_combatants.length > 0 ||
      delay_combatants.length > 0 ||
      marker_combatants.length > 0
    ) {
      //-------------------
      // record cur action
      //-------------------
      return_parm.cur_action = i
      //-----------------------------------------------------------------
      // unused action count for cur action = pendings + delays + markers
      //-----------------------------------------------------------------
      return_parm.unused_action_count =
        pending_combatants.length + delay_combatants.length + marker_combatants.length
      break
    }
  }
  //----------------------------------------
  // flag end of round where no o/s actions
  //----------------------------------------
  if (return_parm.cur_action == 0) {
    console.log('***** must be end of round')
    return_parm.cur_action = 99
  }
  return return_parm
}
